// extracted by mini-css-extract-plugin
module.exports = {"container":"Reminder_container__EBrFJ","image":"Reminder_image__HLCYZ","background":"Reminder_background__BPNsK","text":"Reminder_text__2x0zn"};